//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../no/ugmath.js";
let d=[[[0,"Type",1,0]],[[["dimensionPtID"],"GetDimensionPointLocation",{R_:{dimensionPtLocation:''}},1,0],[["dimensionPtID","dimensionPtLocation"],"SetDimensionPointLocation",{},2,0],[["dimensionPtID"],"DeleteDimensionPoint",{},1,0],[[],"CreateDimensionPoint",{R_:{dimensionPt:''}},0,0]],[]];
SPLM.AME.ManageDimensionPointsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.ManageDimensionPointsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.ManageDimensionPointsBuilder.Types = Object.freeze({
    "Automatic" : "Automatic", "Manual" : "Manual"});

export default SPLM;